import React from 'react';
import PropTypes from 'prop-types';

import {Box, Stack, Typography} from 'views/components';
import {Translate} from 'views/module';
import {CalendarMonthOutlined} from 'views/icons';

import CardPaper from './CardPaper';

const RequiredDaysCard = (props) => {
  const {jobDataParsed} = props;

  return (
    <CardPaper>
      <Stack direction="row" spacing={1} alignItems="center" sx={{mb: 1}}>
        <CalendarMonthOutlined fontSize="small" />
        <Typography variant="body2" sx={{fontWeight: 700}}>
          <Translate expression='jobDetail.RequiredDays.Title' />
        </Typography>
      </Stack>

      <Box sx={{display: 'flex', flexWrap: 'wrap', gap: 1}}>
        {/* Live-in*/}
        {
          jobDataParsed.recurrenceType === 'LIVEIN_EVENT' &&
            <Box
              sx={{
                px: 1.25,
                py: 0.75,
                borderRadius: 2,
                bgcolor: 'rgba(0,0,0,0.04)',
                border: '1px solid rgba(0,0,0,0.06)',
              }}
            >
              <Typography variant="caption" sx={{fontWeight: 700}}>
                {jobDataParsed.hoursPerWeekString}
              </Typography>
            </Box>
        }
        {/* Recurrence */}
        {
          jobDataParsed.recurrenceType === 'RECURRENCE_EVENT' &&
            jobDataParsed.scheduleStringsFormated.map((s, i) => (
              <Box
                key={i}
                sx={{
                  px: 1.25,
                  py: 0.75,
                  borderRadius: 2,
                  bgcolor: 'rgba(0,0,0,0.04)',
                  border: '1px solid rgba(0,0,0,0.06)',
                }}
              >
                <Typography variant="caption" sx={{fontWeight: 700}}>
                  {s}
                </Typography>
              </Box>
            ))
        }
      </Box>
    </CardPaper>
  );
};

RequiredDaysCard.propTypes = {
  jobDataParsed: PropTypes.object.isRequired,
};

export default RequiredDaysCard;
